import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { ICategorySFilter } from 'src/@types/SearchFilterTypes';
import { withEnvironment } from 'src/models/extensions/withEnvironment';
import { withPagination } from 'src/models/extensions/withPagination';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { categoryApi } from 'src/service';

import { Category, ICategory } from '../category/Category';

/**
 * # CategoryStore
 *
 * CategoryStore을 설명하세요.
 */
export const CategoryStore = types
  .model('CategoryStore')
  .props({
    // 전체 카테고리
    categories: types.optional(types.array(Category), []),
    // 전체 카테고리 트리 형태
    categoryTree: types.optional(types.array(Category), []),
    // 최상위 카테고리
    topLevelCategories: types.optional(types.array(Category), []),
  })
  .extend(withEnvironment)
  .extend(withPagination)
  .actions(withSetPropAction)
  .actions((self) => ({
    setCategories: (categories: ICategory[]) => {
      self.categories.replace(categories);
    },
    setCategoryTree: (subCategory: ICategory[]) => {
      self.categoryTree.replace(subCategory);
    },
    setTopLevelCategories: (topLevelCategories: ICategory[]) => {
      self.topLevelCategories.replace(topLevelCategories);
    },
  }))
  .actions((self) => {
    /**
     * 카테고리 조회
     * @param
     */
    const getCategory = async (searchFilter?: ICategorySFilter) => {
      try {
        const result = await categoryApi.getCategory(searchFilter);
        if (result && result.success) {
          // 목록 리스트
          self.setCategories(result.data as ICategory[]);

          // 최상단 카테고리: healthcare, ict
          const topCategory = result.data.filter((category) => !category.categoryPsid);
          self.setTopLevelCategories(topCategory as ICategory[]);
        } else {
          return {
            success: false,
            message: '카테고리 조회 실패',
          };
        }
      } catch (error) {
        console.error(error);
        throw new Error('카테고리 조회 실패');
      }
    };
    /**
     * 카테고리 트리 조회
     * @param
     */
    const getCategoryTree = async (searchFilter?: ICategorySFilter) => {
      try {
        const result = await categoryApi.getCategoryTree(searchFilter);

        if (result && result.success) {
          // 목록 리스트
          self.setCategoryTree(result.data as ICategory[]);

          // 최상단 카테고리: healthcare, ict
          const topCategory = result.data.filter((category) => !category.categoryPsid);
          self.setTopLevelCategories(topCategory as ICategory[]);

          return {
            success: true,
            data: result.data,
          };
        } else {
          return {
            success: false,
            data: null,
          };
        }
      } catch (error) {
        console.error(error);
        throw new Error('카테고리 조회 실패');
      }
    };

    const getDetail = async (categorySid: number) => {
      try {
        const result = await categoryApi.getDetail(categorySid);
        return {
          success: true,
          data: result,
        };
      } catch (error) {
        console.error(error);
        throw new Error('카테고리 조회 실패');
      }
    };

    // const buildCategoryTree = (categories: ICategory[]): ICategory[] => {
    //   const categoryMap: Record<number, ICategory> = {};

    //   // 모든 카테고리를 맵에 저장
    //   categories.forEach((category) => {
    //     categoryMap[category.categorySid] = {
    //       ...category,
    //       children: [] as ICategory[], // MST 배열로 초기화
    //     } as ICategory;
    //   });

    //   // 트리 구성
    //   const tree: ICategory[] = [];
    //   categories.forEach((category) => {
    //     if (category.categoryPsid && categoryMap[category.categoryPsid]) {
    //       categoryMap[category.categoryPsid].children?.push(categoryMap[category.categorySid]);
    //     } else {
    //       tree.push(categoryMap[category.categorySid]); // 최상위 카테고리
    //     }
    //   });

    //   return tree;
    // };

    return {
      getCategory,
      getCategoryTree,
      getDetail,
      // buildCategoryTree,
    };
  });

// --------------------------------------------------------------------------
type TCategoryStore = Instance<typeof CategoryStore>;
type TCategoryStoreSnapshot = SnapshotOut<typeof CategoryStore>;

export interface ICategoryStore extends TCategoryStore {}
export type TCategoryStoreKeys = keyof TCategoryStoreSnapshot & string;
export interface ICategoryStoreSnapshot extends TCategoryStoreSnapshot {}
export const createCategoryStore = () => types.optional(CategoryStore, {} as TCategoryStore);
